module.exports = __webpack_public_path__ + "media/images/team-card-default-33322561.jpg";